import { Box, Paper, Typography } from '@mui/material';
import { Warning } from 'phosphor-react';
import { ReactNode } from 'react';
import { Color } from 'core';

interface WarningBannerProps {
  title: string;
  children: ReactNode;
  sx?: object;
}

export const WarningBanner = ({ title, children, sx = {} }: WarningBannerProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: Color.successGreen,
        color: Color.veryDarkOrange,
        border: `1px solid ${Color.successGreen}`,
        p: 3,
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        ...sx,
      }}
    >
      <Warning size={24} weight="fill" style={{ marginRight: '12px', flexShrink: 0 }} />
      <Box>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 1, color: Color.veryDarkOrange }}>
          {title}
        </Typography>
        <Box sx={{ color: Color.veryDarkOrange }}>{children}</Box>
      </Box>
    </Paper>
  );
};
